<template>
    <FormItem
        label="Step信息"
        v-show="data"
        :style="{borderBottom:'1px solid #ccc',paddingBottom:'20px'}"
    >
        <Button
            v-show="showType==1&&data"
            type="primary"
            v-clipboard:copy="JSON.stringify(data)"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
        >复制信息</Button>&nbsp;&nbsp;
        <Button type="info" @click="showCopyModel" v-show="showType==2">粘贴信息</Button>&nbsp;&nbsp;
        <Modal v-model="copyModel" title="生成Step信息" @on-ok="setData" @on-cancel="hideCopyModel">
            <Input
                v-model="copyData"
                type="textarea"
                :autosize="{minRows: 10}"
                placeholder="请先粘贴复制的Step信息, 然后点击确定, 生成信息"
            />
        </Modal>
    </FormItem>
</template>

<script>
export default {
    data: () => ({
        copyModel: false,
        copyData: ""
    }),
    props: ["data", "showType"],
    methods: {
        setData() {
            let _data = JSON.parse(this.copyData);
            this.$emit("copy", _data);
        },
        showCopyModel() {
            this.copyModel = true;
            this.copyData = "";
        },
        hideCopyModel() {
            this.copyData = "";
            this.copyModel = false;
        },
        onCopy: function() {
            this.$Message.success("已复制到剪切板");
        },
        onError: function() {
            this.$Message.error("复制失败");
        }
    }
};
</script>

<style>
</style>